import { useSelector } from "react-redux";
import { getUserPermissions } from '../data/permissions/permissionsSlice';

const changeCostsPermission = "changeCosts"; // to unlock cost inputs, the current user must have this permission

export const useCostLock = (inputName) => {
    const userPermissions = useSelector(getUserPermissions); // retrieve a list of the user's permissions from Redux
    if (!inputName) return false;

    // if the input name starts with "unlocked_", the cost is not locked (e.g.: when creating a custom item in BasketItemModal)
    if (inputName.toLowerCase().startsWith("unlocked_")) return false;

    // check if the input name includes "cost" and the user does not have the "changeCosts" permission
    return inputName.toLowerCase().includes("cost") && !userPermissions.includes(changeCostsPermission)
}